import {Resource} from 'app/service/resource/classes/resource.class';

export abstract class AbstractResourceComponentClass {
    public abstract setResource(resource: Resource): void;
}
